// Namespaced so they never collide with other dashboards' identically-named types in the finance LP.
export const FETCH_DATA_REQUEST = 'aiDashboard/FETCH_DATA_REQUEST';
export const FETCH_DATA_SUCCESS = 'aiDashboard/FETCH_DATA_SUCCESS';
export const FETCH_DATA_FAILED = 'aiDashboard/FETCH_DATA_FAILED';
